import { TerminationOfExistingContract } from "features/contracting/enums/terminationOfExistingContract";
import PageCard from "features/shared/components/card/PageCard";
import FormGroup from "features/shared/forms/components/FormGroup";
import RadioBox from "features/shared/forms/components/radioBox/RadioBox";
import {
  BindCheckFieldFunction,
  FormErrors,
} from "features/shared/forms/hooks/useForm";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  bindCheckField: BindCheckFieldFunction;
  errors: FormErrors;
};

const ContractingProcessType = ({ bindCheckField, errors }: Props) => {
  // translations
  const tTypes = useTranslation(
    "contracting\\enums\\terminationOfExistingContract"
  ).t;
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "contractingProcessType");

  // sub-renders
  const renderTypes = () => {
    const processTypes = Object.keys(TerminationOfExistingContract).filter(
      (x) =>
        x !== "Undefined" &&
        x !== String(TerminationOfExistingContract.NoPlaceOfDeliveryNotExists) // TODO: docasne skryti moznosti (OPM neexistuje)
    );

    return processTypes.map((type) => (
      <div className="col-lg-6 px-2" key={type}>
        <RadioBox
          label={tTypes(`${type}.title`)}
          text={tTypes(`${type}.subtitle`)}
          icon={{ icon: "comment-dots" }}
          {...bindCheckField("terminationOfExistingContract", type)}
        />
      </div>
    ));
  };

  // render
  return (
    <PageCard
      title={tLabels("cardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <FormGroup validationError={errors["terminationOfExistingContract"]}>
        <div className="row no-gutters mx-n2">{renderTypes()}</div>
      </FormGroup>
    </PageCard>
  );
};

export default ContractingProcessType;
